var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"custom-table__head table__head"},[_c('tr',_vm._l((_vm.head),function(th){return _c('th',{key:th.title,staticClass:"custom-table__th table-border-bottom-bold"},[_vm._v(" "+_vm._s(th.title)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }